import Image from 'app/Components/Shared/Image/image';
import React, {Fragment, useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import {
  AbroadPackageClientState,
  ClientType,
  lobyTabsEnum,
  PackageOrigin,
  SubscriberModel,
  ObjectWithField,
} from '../CellcomAbroadLobbyBlock/Shared/Models/AbroadPackageModels';
import {getEpiGeneralData} from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice.js';
import {fetchPackagePopularMarket, fetchPackagePopular } from '../../Block/CellcomAbroadLobbyBlock/Shared/abroadThunk';
// import '../Sass/AbroadPackagesPopular.scss';
import {useInView} from 'react-intersection-observer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import {gaEvent} from '../../../utilities/analytics/tracking.js';
import constants from '../../../utilities/analytics/constants.js';
import AbroadPackageClient from '../CellcomAbroadLobbyBlock/Shared/Components/AbroadPackage';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation} from 'swiper';
import AbroadWithoutPackage from './abroadWithoutPackage/AbroadWithoutPackage';
import SelfCareAbroadPackagesPopularSkeleton from './SelfCareAbroadPackagesPopularSkeleton';
import {isThereValidPackages} from '../SelfCareAbroadCustomerExistingPackagesBlock/SelfCareAbroadCustomerExistingPackagesMain';
import { isNullOrEmpty, prepareSameWindowUrlWithNavigateTo } from 'app/utilities/StringHelpers/StringHelpers';
interface RequestPackagePopular {
  socIdList: string[];
  blockId: number;
  clientType: ClientType;
}
interface AbroadPackagePopularProps {
  id?: number;
  context?: IEpiserverContext;
  cellcomAbroad: AbroadPackageClientState;
  fetchPackagePopular: Function;
  fetchPackagePopularMarket: Function;
  getEpiGeneralData: Function;
  showAppLoader: Function;
  hideAppLoader: Function;
  requestPackagePopular: RequestPackagePopular;
  orderEvent: Function;
  isLobby?: boolean;
  isPopularMarketOrLobby: PackageOrigin;
  subscriber: SubscriberModel;
  noAbroadNoPackageMainHeading: string;
  noAbroadNoPackageSubHeading: string;
  abroadNoPackagesMainHeading: string;
  abroadNoPackageSubHeading: string;
  buttonText: string;
  AbroadWithoutPackageImg: string;
  ArrowImg: string;
  urlToExtendedPackages: string;
  selfCareAbroadPackages :any;
  packagesPopularMarket :any;
  abroadUsage : any;
}

const SelfCareAbroadPackagesPopular = (props: AbroadPackagePopularProps) => {
  const aboardBlocksToShow = props.packagesPopularMarket?.data; 
  const aboardBlocksStatus = props.packagesPopularMarket?.status;
  const abroadPackagesStatus = props.selfCareAbroadPackages?.status;
  const abroadPackages = props.selfCareAbroadPackages?.regularPackages;
  const effPackage = (props.abroadUsage?.data as ObjectWithField)?.effectivePackagesToShow;
  const noPackAbroad = isNullOrEmpty(effPackage) && emptyUpdateOrRemove(abroadPackages) && props.subscriber?.abroadSocInd === 'Y';
  const noPackNoAbroad = isNullOrEmpty(abroadPackages) && props.subscriber?.abroadSocInd === 'N';



  const {ref, inView} = useInView({
    threshold: 0.8,
    triggerOnce: true,
  });
  useEffect(() => {
    const fetchDataFromMarket = async () => {
      await props.fetchPackagePopularMarket({
        SocIdList: props.requestPackagePopular.socIdList,
        BlockId: props.requestPackagePopular.blockId,
        ClientType: props.requestPackagePopular.clientType,
        Id: props.id,
        subscriber: props.subscriber?.productSubscriberNo,
      });
    };
    if(abroadPackagesStatus == "fulfilled"){
      if( (noPackAbroad || noPackNoAbroad) && !aboardBlocksToShow || aboardBlocksToShow?.[props.id]?.length === 0){
          fetchDataFromMarket();
        }
    }
  }, [props.subscriber?.productSubscriberNo , abroadPackagesStatus]);

  useEffect(() => {
    if (props.isLobby && props.cellcomAbroad.activeLobbyTab === lobyTabsEnum.PRIVATE) {
      const {category, eventType, eventParams} = constants.ABROAD_LOBBY_POPULAR_ARE_SHOWN_PRIVATE;
      gaEvent(category, eventType, eventParams);
    }
    if (props.isLobby && props.cellcomAbroad.activeLobbyTab === lobyTabsEnum.BUSINESSACCOUNT) {
      if (props.cellcomAbroad.otpData.validatedCostumerData?.isSeparatedSale) {
        const {category, eventType, eventParams} = constants.SEPARATED_POPULARPACKAGES_SHOW;
        gaEvent(category, eventType, eventParams);
      } else {
        const {category, eventType, eventParams} = constants.ABROAD_LOBBY_POPULAR_ARE_SHOWN_BUSINESS;
        gaEvent(category, eventType, eventParams);
      }
    }
  }, [props.cellcomAbroad.activeLobbyTab]);

  const packageListRender = (block?) => {
    return !isMobile ? (
      <div className='self-care-abroad-packages-popular'>
        {block?.map((pack, index) => {
          return (
            <AbroadPackageClient
              key={index}
              packageData={pack}
              orderEvent={props.orderEvent}
              supportedApps={props.cellcomAbroad.getEpiGeneralData.supportedApps}
              context={props.context}
              isSearchOrPopular={props.isPopularMarketOrLobby}
              isPrivateOrBusiness={props.cellcomAbroad.activeLobbyTab}
              isSeparatedSale={props.cellcomAbroad.otpData.validatedCostumerData?.isSeparatedSale}
            />
          );
        })}
      </div>
    ) : (
      <Swiper
        className={block?.length>1?'swiper-item':'single-item'}
        centeredSlides={true}
        centerInsufficientSlides={true}
        spaceBetween={block?.length > 1 ? 25 : 0}
        slidesPerView={block?.length > 1 ? 1.2 : 1}
        enabled={true}>
        {block?.map((pack, index) => (
          <SwiperSlide key={index}>
            <AbroadPackageClient
              packageData={pack}
              orderEvent={props.orderEvent}
              supportedApps={props.cellcomAbroad.getEpiGeneralData.supportedApps}
              context={props.context}
              isSearchOrPopular={props.isPopularMarketOrLobby}
              isPrivateOrBusiness={props.cellcomAbroad.activeLobbyTab}
              isSeparatedSale={props.cellcomAbroad.otpData.validatedCostumerData?.isSeparatedSale}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    );
  };


  function emptyUpdateOrRemove(abroadPackages) {
    if (abroadPackagesStatus !== 'pending' ) {
      return !isThereValidPackages(abroadPackages);
    }
    return true;
  }

  function renderingAccordingToDataStatus() {

    var noAbroadPackages = noPackAbroad || noPackNoAbroad;

    if (aboardBlocksStatus == "pending") {
      return <SelfCareAbroadPackagesPopularSkeleton />;
    }
    else if (noAbroadPackages && aboardBlocksToShow?.[props.id]?.length > 0) {
      return (
          <>
            <div className='self-care-abroad-market-popular-main-wrapper'>
              {noPackNoAbroad && (
                <div className='costumer-no-packages-not-abroad'>
                  <span className='main-heading'>{props.noAbroadNoPackageMainHeading}</span>
                  <span className='sub-heading'>{props.noAbroadNoPackageSubHeading}</span>
                </div>
              )}
               {noPackAbroad && (
                <AbroadWithoutPackage
                  icon={props.AbroadWithoutPackageImg}
                  title={props.abroadNoPackagesMainHeading}
                  subTitle={props.abroadNoPackageSubHeading}
                />
               )}

              <div className='self-care-abroad-market-popular-main'>
                <Container className={`${!isMobile ? `pr-0 pl-0 m-auto abroad-market-popular__desktop` : ''}`}>
                  <Row className={'mb-1 justify-content-center'}>{packageListRender(aboardBlocksToShow[props.id])}</Row>
                </Container>
              </div>
            </div>

            <div className='button-container' onClick={() => props.urlToExtendedPackages && prepareSameWindowUrlWithNavigateTo(props.urlToExtendedPackages, props.context)}>
              <span className='button-text'>{props.buttonText}</span>
              <Image className='button-img' src={props.ArrowImg} alt='left-arrow' />
            </div>
          </>
      );
    }
    return null;
  }

  return <div ref={ref} className='self-care-abroad-market-popular-process'>{renderingAccordingToDataStatus()}</div>;
};

const mapStateToProps = ({cellcomAbroad, selfcarePage}: {cellcomAbroad: AbroadPackageClientState, selfcarePage: any}) => {
  return {
    cellcomAbroad,
    selfCareAbroadPackages: selfcarePage.selectedSubscriber?.abroadPackages,
    packagesPopularMarket: selfcarePage.selectedSubscriber?.packagesPopularMarket,
    abroadUsage : selfcarePage.selectedSubscriber?.abroadUsage,
  };
};

export default React.memo(
  connect(mapStateToProps, {
    fetchPackagePopular,
    getEpiGeneralData,
    fetchPackagePopularMarket,
  })(SelfCareAbroadPackagesPopular),
);
